import CityPageTemplate from "../city-template/CityPageTemplate";
import { anaheimConfig } from "./data";

export default function AnaheimPage() {
  return <CityPageTemplate config={anaheimConfig} />;
}